import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import L from 'leaflet'
import MarkerClusterGroup from 'react-leaflet-cluster'
import 'leaflet/dist/leaflet.css'
import {
  MapContainer,
  useMapEvent,
  TileLayer,
  ZoomControl,
  Popup,
  FeatureGroup,
  Polygon,
  Marker,
} from 'react-leaflet'
import GeomanComponent from './GeomanComponent/GeomanComponent'
import {Checkbox} from 'primereact/checkbox'
import {InputText} from 'primereact/inputtext'
import ButtonComponent from '../../ButtonComponent/ButtonComponent'
import tagIconImg from '../../../../assets/icons/tag-icon.gif'
import locationIcon from '../assets/icons/location.png'
import _ from 'lodash'
import './style.css'
import GeofenceEditorComponent from './Editors/GeofenceEditorComponent'
import {useDispatch} from 'react-redux'
import {saveGeofencing} from '../../../../store/slices/geofencing.slice'
import GeofenceListComponent from './List/GeofenceListComponent'
import {useAppSelector} from '../../../../hooks'
import IconMap from '../assets/icons/marker.png'
import RedMarker from '../assets/icons/redMarker.png'
import assetConfigs from '../../../../configs/index'

import {
  fetchGeofencings,
  getGeofences,
  getSelectedGeoClient,
  getSelectedGeofenceId,
  getSelectedGeofenceIds,
} from '../slice/geofencing.slice'
import {Chip} from 'primereact/chip'
import {OverlayPanel} from 'primereact/overlaypanel'
import * as turf from '@turf/turf'
import {
  fetchEngById,
  fetchEngines,
  fetchEnginesMap,
  getGeoByIdSite,
  getLastEnginsUpdates,
  getSelectedEnginMap,
  setSelectedEnginMap,
} from '../../../Engin/slice/engin.slice'
import {fetchPointsGeo} from '../slice/navixy.slice'
import {fetchSites, getSelectedSite, getSites} from '../../../Site/slice/site.slice'
import GeocodingComponent from '../../GeocodingComponent/GeocodingComponent'
import {OlangItem} from '../../Olang/user-interface/OlangItem/OlangItem'
import BaseMapLayerComponent from '../../BaseMapLayerComponent/BaseMapLayerComponent'
import {useLocalStorage} from 'primereact/hooks'
import {Image} from 'primereact/image'
import moment from 'moment'
import {
  fetchCompanyAddresses,
  getCompanyAddresses,
  getSelectedAddress,
  getSelectedCompany,
} from '../../../Company/slice/company.slice'
import {Button} from 'primereact/button'
import {Paginator} from 'primereact/paginator'
import {setToastParams} from '../../../../store/slices/ui.slice'
import NavixyVehiclesListComponent from './List/NavixyVehiclesListComponent'
import {classNames} from 'primereact/utils'
import { lastSeenBodyTemplate } from '../../../../cors/utils'
import ReactDOMServer from "react-dom/server";

const layers = [
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
  'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
]

let tagIcon = new L.Icon({
  iconUrl: locationIcon,
  // iconSize: [30, 30],
  // shadowSize: [50, 64],
  // iconAnchor: [22, 94],
  // shadowAnchor: [4, 62],
  // popupAnchor: [-15, -90],
  // iconSize: [30, 30],
  // shadowSize:   [50, 64],
  // iconAnchor:   [22, 94],
  // shadowAnchor: [4, 62],
  // popupAnchor:  [-15, -90]
})

const customIcon = new L.Icon({
  iconUrl: IconMap,
  iconSize: [60, 60],
})
const redIcon = new L.Icon({
  iconUrl: RedMarker,
  iconSize: [50, 50],
  iconAnchor: [25, 25],
})
// ${
//   options?.showMarker !== false
//     ? `<img src="${IconMap}" width="30" height="30" alt="icon"/>`
//     : ''
// }${
// options?.showMarker !== false ? 'flex' : 'block'
//} ;

let dvIcon = (options) => {
  return L.divIcon({
    html: `
         <div class="bg-transparent flex align-items-center gap-2" style="width: 150px">
            <div class="bg-blue-500 flex align-items-center justify-content-center" style="width: 50px ; height: 50px;border-radius: 50%">
              <span class="pi pi-truck text-white text-2xl" />
            </div>
            <div class="p-1 bg-blue-500 text-white shadow-2 " style="${options?.style}">
              <strong class="text-lg">${options.label}</strong>
            </div>
         </div>
      `,
    iconAnchor: [7, 15],
    shadowAnchor: [4, 62],
    popupAnchor: [0, -15],
    iconSize: [15, 15],
    className: '',
  })
}

const createClusterCustomIcon = (cluster) => {
  return L.divIcon({
    html: `<span>${cluster.getChildCount()}</span>`,
    className: 'my-custom-cluster', // Apply custom CSS styles
    iconSize: L.point(50, 50, true), // Set the size of the cluster icon
  })
}

const createTrackerClusterCustomIcon = (cluster) => {
  return L.divIcon({
    html: `
    <span style="font-size: 30px">${cluster.getChildCount()}</span>
    `,
    className: 'my-custom-cluster bg-orange-500',
    // Apply custom CSS styles
    iconSize: L.point(50, 50, true), // Set the size of the cluster icon
  })
}
const MapComponent = ({
  layers,
  actions,
  showToolbar,
  markerNameKey,
  itemDetailTemplate,
  itemTemplate,
  children,
  groups,
  groupsEnter,
  groupsStatus,
  pios,
  piosPosition,
  toolbarOptions,
  groupPioBy,
  onSaveGeofence,
  type,
  pioPopupTemplate,
  loadingShowMore,
  showMoreClick,
  onChangePagination,
  totalRecords,
  onSearch,
  isLastPage,
  filterSt,
  statusVal,
  etatVal,
  filterEt,
}) => {
  const [showGeoman, setShowGeoman] = useState(true)
  const [showEditForm, setShowEditForm] = useState(false)
  const [showVehicles, setShowVehicles] = useState(false)
  const [showGeofences, setShowGeofences] = useState(false)
  const [showFilterOptions, setShowFilterOptions] = useState(false)
  const [currentLayer, setCurrentLayer] = useState(null)
  const [piosList, setPiosList] = useState([])
  const [showPios, setShowPios] = useState(true)
  const [currentHoveredItem, setCurrentHoveredItem] = useState(null)
  const [selectedPioIds, setSelectedPioIds] = useState([])
  const [selectedPioGroups, setSelectedPioGroups] = useState([])
  const [geoNavixy, setGeoNavixy] = useState([])
  const [geoLayers, setGeoLayers] = useState({})
  const sites = useAppSelector(getSites)
  const [geofences, setGeofences] = useState([])
  const [groupBy, setGroupBy] = useState('')
  const [groupByName, setGroupByName] = useState('')
  const [filterPioBy, setFilterPioBy] = useState('')
  const [filterByName, setFilterByName] = useState('')
  const [filterEtat, setFilterEtat] = useState({label: 'All', value: 'All'}, 'state')
  const [filterStatus, setFilterStatus] = useState({status: 'All', label: 'All'}, 'status')
  const [featureFilterType, setFeatureFilterType] = useState('')
  const [inputFilter, setInputFilter] = useState('')
  const [pointFilterLatLng, setPointFilterLatLng] = useState('')
  const [polygonFilterLayer, setPolygonFilterLayer] = useState([])
  const [filteredPiosList, setFilteredPiosList] = useState([])
  const [enginMarker, setEnginMarker] = useState(null)
  const [navCenter, setNavCenter] = useState(null)
  const [mapZoom, setMapZoom] = useState(false)
  const [first, setFirst] = useState(0) 
  const [hideClusters, setHideClusters] = useState(false);
  const [rows, setRows] = useState(10)
  const [zoom, setZoom] = useState(0)
  const [selectedGeo, setSelectedGeo] = useState(null)
  const [engMap, setEngMap] = useState([])
  const [trackers, setTrackers] = useState([])
  const [filtredTrackers, setFilteredTrackers] = useState([])
  const [currentTracker, setCurrentTracker] = useState(null)
  const [clusterPopup, setClusterPopup] = useState(null)



  const selectedGeofence = useAppSelector(getSelectedGeoClient)
  const [selectedGeofencePropreties, setSelectedGeofencePropreties] = useState(null)

  const [realList, setRealList] = useState([])
  const mapRef = useRef(null)
  const piosRef = useRef(null)
  const editorRef = useRef(null)
  const pioDetailMap = useRef(null)
  const groupOverlayRef = useRef(null)
  const geoClustersRef = useRef(null)
  const filterOverlayRef = useRef(null)
  const filterOverRefEtat = useRef(null)
  const filterOverRefStatus = useRef(null)
  const getDetailRef = useRef(null)
  const enginMapOld = useRef([])
  const trackerRef = useRef()

  const dispatch = useDispatch()

  const [poiInfos, setPioInfos] = useState(null)
  const [selectedPio, setSelectedPio] = useState(null)
  const [geofencesClusters, setGeofencesClusters] = useState([])

  const selectedEnginMap = useAppSelector(getSelectedEnginMap)
  const lastEnginsUpdates = useAppSelector(getLastEnginsUpdates)
  const addressCompany = useAppSelector(getCompanyAddresses)
  const selectedIdsGeo = useAppSelector(getSelectedGeofenceIds)

  const [centerMap, setCenterMap] = useState([addressCompany?.lat || 0, addressCompany?.lng || 0])

  const MapEvents = () => {
    useMapEvent('click', (e) => {
      if (featureFilterType == 'point') {
        setPointFilterLatLng(e.latlng)
        mapRef.current.flyTo(e.latlng)
      } else if (featureFilterType == 'polygon') {
      }
    })
    useMapEvent('zoom', (e) => {
      setZoom(e.target._zoom)
    })
    useMapEvent('popupclose', (e) => {
      setHideClusters(false)
    })
    useMapEvent('overlayadd', (e) => {
      console.log('event:', e)
    })
    useMapEvent('popupclosed', (e) => {
      console.log('event:', e)
    })
    useMapEvent('pm:create', (e) => {
      if (featureFilterType !== 'polygon') {
        setShowEditForm(true)
        setCurrentLayer(e)
      } else {
        setTimeout(() => {
          setPolygonFilterLayer(e)
        }, 10)

        setTimeout(() => {
          toggleButtons()
        }, 1000)
        e.layer.on('pm:remove', (e) => {
          console.log('removedddd')
          setPolygonFilterLayer(null)
        })
      }
    })
    useMapEvent('pm:globaleditmodetoggled', (e) => {
      console.log('globaleditmodetoggled:', e.target)
      if (!e.enabled) {
        setShowEditForm(true)
        // setCurrentLayer(e)
        setSelectedGeofencePropreties({})
      }
    })
    useMapEvent('pm:globalremovalmodetoggled', (e) => {
      console.log('globaleditmodetoggled:', e)
    })
  }

  const getPiosInPolygon = () => {
    if (getDetailRef.current) return
    if (typeof polygonFilterLayer?.layer?.toGeoJSON != 'function') return _.cloneDeep(realList)
    let geojsonLayer = polygonFilterLayer?.layer?.toGeoJSON()
    let layer = polygonFilterLayer?.layer
    let options = {
      type: polygonFilterLayer.shape.toLowerCase(),
      radius: layer?.options?.radius,
      center: layer?._latlng,
    }

    let containedPios = findPointsInLayer(_.cloneDeep(realList), geojsonLayer, options)
    return containedPios
  }

  const onClickMarker = (pio) => {
    dispatch(setSelectedEnginMap(pio))
  }

  function isPointInLayer(latlng, layer, options) {
    latlng = turf.point(Array.isArray(latlng) ? latlng : [latlng.lng, latlng.lat])
    let isInside = false

    if (!/^circle$/.test(options?.type || '')) {
      isInside = turf.inside(latlng, layer)
    } else {
      if (options?.center) {
        // let circle = turf.circle(turf.point(Array.isArray(options?.center) ? options?.center :[options?.center?.lng , options?.center?.lat]) , options?.radius);
        let center = turf.point(
          Array.isArray(options?.center)
            ? options?.center
            : [options?.center?.lng, options?.center?.lat]
        )
        isInside = turf.distance(center, latlng, {units: 'meters'}) <= options?.radius // turf.inside(latlng , circle)
        console.log('circle:', isInside, options?.radius)
      }
    }
    return isInside
  }

  function findPointsInLayer(featuresPoint, layer, options) {
    let insides = []
    for (let point of featuresPoint) {
      if (isPointInLayer(point, layer, options)) insides.push(point)
    }
    return insides
  }
  const onFilter = (text) => {
    const trimmedText = text.trim().toLowerCase()
    setInputFilter(text)
    console.log('trimmedText:', trimmedText)
    onSearch(text)
    if (trimmedText !== '') {
      let normalizedText = trimmedText.toLowerCase().trim()
      let filterData = _.cloneDeep(enginMapOld.current).filter((item) =>
        item.reference.toLowerCase().startsWith(normalizedText)
      )
      if (etatVal && etatVal.value !== 'all') {
        filterData = filterData.filter((item) => item.etatenginname === etatVal.value)
        console.log('Filtered by etatVal:', filterData)
      }

      if (statusVal && statusVal.value !== 'all') {
        filterData = filterData.filter((item) => item.statusname === statusVal.value)
        console.log('Filtered by statusVal:', filterData)
      }
      filterData = _.uniqBy(filterData, 'id')
      setEngMap(filterData)
    } else {
      // Reset to original data
      console.log('esle data ', enginMapOld.current)
      const getUnique = _.uniqBy(enginMapOld.current, 'id')
      setEngMap(getUnique)
    }
  }

  const onPageChange = (event) => {
    setFirst(event.first)
    setRows(event.rows)
    onChangePagination(event.page + 1, event.rows)
  }

  const toggleSelectPio = (id, add, item) => {
    setSelectedPioIds((prev) => {
      if (add) return [...prev, id]
      return prev.filter((pio) => pio != id)
    })
  }

  const toggleSelectPioGroup = (group, select) => {
    let groupItem = piosList.find((f) => f.label == group)
    if (groupItem) {
      let ids = groupItem.items.map((o) => o.id)
      setSelectedPioIds((prev) => {
        if (select) return [...prev, ...ids]
        return prev.filter((pio) => !ids.includes(pio))
      })

      setSelectedPioGroups((prev) => {
        if (select) return [...prev, group]
        return prev.filter((pio) => pio != group)
      })
    }
  }

  const toggleFilter = (list) => {
    // Deep clone and filter out items with lat of 0
    const itemsList = _.cloneDeep(list).filter((item) => item?.lat !== 0)

    console.log('ffff filterStatus:', filterStatus)
    console.log('ffff filterEtat:', filterEtat)

    // Helper functions for filtering by status and state
    const filterByStatus = (item) =>
      filterStatus?.label === 'All' || item.sysStatus === filterStatus?.status
    const filterByEtat = (item) =>
      filterEtat?.label === 'All' || item.etatenginname === filterEtat?.value

    // Filter items based on both status and state
    const filteredItems = itemsList.filter((item) => filterByStatus(item) && filterByEtat(item))

    // Extract IDs and update selected items
    const selectedIds = filteredItems.map((item) => item.uid)
    setSelectedPioIds(selectedIds)

    // Create a new list with the filtered items and update state
    const updatedList = {
      ...piosList[0],
      items: filteredItems,
    }
    setPiosList([updatedList])

    // Debug log for filtered items
    console.log('selectedIds Items:', selectedIds)
  }

  const filterList = (list, options) => {
    if (!Array.isArray(list || realList)) return
    let filtredList = []
    let filter = filterPioBy || 'label'
    switch (options?.type) {
      case 'text':
        filtredList = (list || realList).filter(
          (pio) =>
            options?.val == '' ||
            (pio?.[filter] || '').toLowerCase().includes(options?.val?.toLowerCase())
        )
        break
      default:
        filtredList = null
    }

    return filtredList
    setSelectedPioIds((prev) => filtredList.filter((o) => prev.includes(o.id)).map((o) => o.id))
    setPiosList(group(filtredList))
  }

  const group = (_list) => {
    let list = _.cloneDeep(_list)
    if (!Array.isArray(list)) list = []
    let isPointFilter =
      (featureFilterType == 'point' && pointFilterLatLng != null) ||
      (featureFilterType == 'polygon' && polygonFilterLayer != null)
    list.forEach((o) => {
      o[groupBy] =
        o[groupBy] == undefined || isPointFilter
          ? 'Non groupé' // groupBy !== 'Tout' && groupByName && !isPointFilter ? groupByName+ ' inconnu(e)': 'Principal'
          : o[groupBy]
    })
    let group = _.groupBy(list, groupBy)
    let groupList = []

    if (Object.keys(group).length == 0)
      group = {
        Principal: list,
      }

    for (let [k, v] of Object.entries(group)) {
      groupList.push({
        label: k,
        items: v,
      })
    }

    const noGroup = groupList.find((g) => g.label == 'Non groupé')
    if (noGroup) {
      groupList = groupList.filter((g) => g.label != 'Non groupé').concat([noGroup])
    }
    console.log('groupp:', groupList)
    return groupList
  }

  function displayGeofences() {
    if (Array.isArray(geofences)) {
      setGeoLayers({})
      if (geoClustersRef.current) geoClustersRef.current.clearLayers()
      setTimeout(() => {
        try {
          if (editorRef.current) editorRef.current.clearLayers()
          let locals = geofences.filter((geo) => geo.idnavixy == null)
          let layers = {}
          for (let o of locals) {
            let _layer = null
            if ((o.type || '').toLowerCase() == 'circle') {
              _layer = L.circle([...o.geometry.geometry.coordinates].reverse(), {
                radius: o.geometry?.properties?.radius,
                color: 'red',
                weight: 0.7,
                id: o.id,
                type: 'circle',
              })

              editorRef.current.addLayer(_layer)
              layers[o.id] = _layer
              continue
            }
            let geo = L.geoJSON(o.geometry, {color: 'red', weight: 0.7, id: o.id})
            geo.eachLayer((layer) => {
              _layer = layer
            })
            if (!_layer) continue
            _layer.on('pm:edit', (e) => {
              setCurrentLayer(e)
              // setShowEditForm(true)
            })
            _layer.on('pm:change', (e) => {
              if (Array.isArray(geofences)) {
                let dt = geofences.find((o) => o.id == e.layer?.options?.id)
                let id = dt.geoid
                dt = _.cloneDeep(dt)
                dt = dt?.properties
                if (dt) {
                  dt.id = id
                  if (typeof dt?.tags == 'string') dt.tags = dt.tags.split('|')
                }
                setSelectedGeofencePropreties(dt)
              }
              setCurrentLayer(e)
              // setShowEditForm(true)
            })
            _layer.on('pm:remove', (e) => {
              console.log('remove:', e)
            })
            //   editorRef.current.addLayer(_layer)
            layers[o.id] = _layer

            // mapRef.current.fitBounds(_layer.getBounds())
          }
          setGeoLayers(layers)
        } catch (e) {
          console.log('Error displaying geofences:' + e.message)
        }
      }, 300)
    }
  }
  const getGeoAndDisplay = async (item) => {
    try {
      editorRef.current.clearLayers()
      const {payload} = await dispatch(getGeoByIdSite(item?.LocationID))
      if (Array.isArray(payload) && payload?.[0]?.geometry?.geometry) {
        const geometry = payload?.[0]?.geometry?.geometry
        const centerOfGeo = turf.centerOfMass(geometry).geometry.coordinates
        if (mapRef.current) mapRef.current.setView(centerOfGeo.reverse(), 19)
        if (geometry) {
          setSelectedGeo(item?.uid)
          let _layer = L.geoJSON(geometry, {color: 'red', weight: 0.7, id: item?.LocationID})
          if (editorRef.current) editorRef.current.addLayer(_layer)
        }
      } else {
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'Erreur lors de la recuperation de la geofence',
            position: 'top-right',
          })
        )
      }
    } catch (e) {
      console.log('getGeoAndDisplay', e)
    }
  }

  const saveGeofenceEdit = useCallback(
    (data) => {
      console.log('data:', data, currentLayer)

      let _layer = currentLayer?.layer

      console.log('_layer:', _layer)

      if (!_layer?.toGeoJSON) return

      let layer = _layer.toGeoJSON()
      layer.properties = {...data, type: currentLayer.shape.toLowerCase()}

      if (Array.isArray(data.tags)) layer.properties.tags = data.tags.join('|')
      if (currentLayer.shape.toLowerCase() == 'circle') {
        layer.properties.radius = _layer?.options?.radius
      }

      console.log('layer:', layer)

      // return
      dispatch(saveGeofencing(layer)).then(({payload}) => {
        console.log('xx layer ', payload)
        if (!payload?.error) {
          _layer.remove()
          setShowEditForm(false)
          setCurrentLayer(null)
          dispatch(fetchGeofencings())
        }
      })
      if (typeof onSaveGeofence == 'function') {
        onSaveGeofence(layer, data)
      }
    },
    [onSaveGeofence, currentLayer]
  )

  const cancelGeofenceEdit = useCallback(
    (data) => {
      setShowEditForm(false)
      if (typeof currentLayer?.layer?.remove == 'function') currentLayer.layer.remove()
      setCurrentLayer(null)
    },
    [currentLayer]
  )
  //test
  const toggleOverlay = (ref, e) => {
    ref.current.toggle(e)
  }

  const sortByNearest = (list) => {
    let lst = _.cloneDeep(list || realList)
    if (pointFilterLatLng == null) return lst

    lst.forEach((l) => {
      let distance = turf.distance([l.lat, l.lng], [pointFilterLatLng.lat, pointFilterLatLng.lng], {
        units: 'meters',
      })
      l.realDistance = distance
      l.distanceTo = distance >= 1000 ? (distance / 1000).toFixed(2) : distance.toFixed(2)
      l.distanceUnit = distance >= 1000 ? 'km' : 'm'
    })
    lst.sort((a, b) => a.realDistance - b.realDistance)
    return lst
  }

  const groupPiosBy = (group, name) => {
    setGroupBy(group)
    setGroupByName(name)
  }

  const toggleFeatureFilterType = (type) => {
    setFeatureFilterType((prev) => (prev == type ? '' : type))
  }

  const displayGeoClusters = () => {
    let clusters = []
    let i = 0
    console.log('vvvv:', Object.entries(geoLayers))
    for (let [k, v] of Object.entries(geoLayers)) {
      let cpt = 0
      console.log('filteredPiosListV:', filteredPiosList)
      let _pioIds = []
      let _pios = []
      for (let o of filteredPiosList) {
        console.log('oiNside:', o)
        if (
          isPointInLayer([o.lng, o.lat], v.toGeoJSON(), {
            type: v?.options?.type,
            center: v?.options?.type == 'circle' ? v?._latlng : null,
            radius: v?.options?.radius,
          })
        ) {
          cpt++
          _pioIds.push(o.id)
          _pios.push(o)
        }
      }
      if (typeof v.getBounds == 'function') {
        console.log('vvvvv:', i, v)
        let latlng = v?._latlng || v.getBounds().getCenter()
        clusters.push({
          latlng: latlng,
          count: cpt,
          layer: k,
          poiIds: _pioIds,
          pios: _pios,
        })
      }
      i++
    }

    setGeofencesClusters(clusters)
  }
  const familleTagTemplate = (rowData) => {
    return (
      <Chip
        title={rowData.tagId != 0 ? `Tagged  ${rowData?.tagDate}` : 'No Tag'}
        alt={rowData.tagId != 0 ? `Tagged  ${rowData?.tagDate}` : 'No Tag'}
        icon={rowData.familleIconTag}
        style={{background: rowData.familleTagIconBgcolor, color: rowData.familleTagIconColor}}
      />
    )
  }
  useEffect(()=>{
    console.log('clusterPopup:', clusterPopup)
  },[clusterPopup])

  function calculateDistance(latlng1, latlng2) {
      const R = 6371; // Radius of the Earth in km
      const dLat = (latlng2.lat - latlng1.lat) * Math.PI / 180;
      const dLon = (latlng2.lng - latlng1.lng) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(latlng1.lat * Math.PI / 180) * Math.cos(latlng2.lat * Math.PI / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in km
  }

  function test(){
    alert('test function called');
  }


  const handleClusterClick2 = (e) => {
    // real cluster layer (depends on version, try propagatedFrom first)
    const cluster = (e.propagatedFrom || e.layer)

    const markers = cluster.getAllChildMarkers()
    if (!markers.length) return;

    const first = markers[0].getLatLng();
    const allSame = markers.every((m) => {
      const ll = m.getLatLng();
      return ll.lat === first.lat && ll.lng === first.lng;
    });

    if (!allSame) {
      // normal behaviour if they are not all in the exact same spot
      cluster.spiderfy();
      return;
    }

    // collect your business data stored on each marker
    const popupItems: Item[] = markers.map((m: any) => m.options.data);

    
  };


  function handleClusterClick(clusterEvent) {
    // setHideClusters(true)
    const cluster = clusterEvent.layer;
    const markers = cluster.getAllChildMarkers();

    // Extract positions
    const positions = markers.map(m =>
      JSON.stringify(m.getLatLng())
    );

    let distances = markers.map( m=> calculateDistance(cluster.getLatLng(), m.getLatLng()))
                           .filter(d => d > 0.010);
    console.log('Cluster positions:', positions ,markers, distances);

    // Check if all positions equal
    const allSame = positions.every(p => p === positions[0]);

    if (distances.length === 0) {
      console.log('markers:', markers)
      let ids = markers.map((m) => m.options?.id);
      console.log('markers ids:', ids);
      let marker_pios = pios.filter((o) => ids.includes(o.id));
      console.log('markers pios:', marker_pios);
      console.log('markers filtredTrackers:', pios);
      let items = markers.map((m) => m.options?.data);
      setClusterPopup({
        position: {...cluster.getLatLng()},
        items: marker_pios,
      })
      const latlng = cluster.getLatLng();
      
      // const element = <PopUpContent marker_pios={marker_pios} onPioClick={(item) => getDetailEngin(item)} />;
      // // Get string HTML
      // const html = ReactDOMServer.renderToString(element);
      // console.log('element:', html);
      // const popupContentt = `
      //   <div class="flex justify-content-start flex-column">
      //      <div>
      //     <h1 style="margin:0;color:#007bff" class="flex align-items-center gap-2 mb-2">
      //       <div class="bg-blue-500 text-white flex justify-content-center align-items-center" style="width: 50px ; height: 50px ; border-radius: 50%">
      //            ${marker_pios.length}
      //       </div> 
      //       <span>Capteurs</span>
      //     </h1>
      //   </div>
      //   ${html}
      //   </div>
       
      // `;
      // L.popup()
      //   .setLatLng(latlng)
      //   .setContent(popupContentt)
      //   .openOn(clusterEvent.target._map);
      return
      // Prevent cluster zoom on click
      clusterEvent.originalEvent.preventDefault();
      clusterEvent.originalEvent.stopPropagation();
    }else{
      cluster.spiderfy()
    }
  }



  const onVehicleFiltered = (data) => {
    setFilteredTrackers(data)
  }

  const onVehiclesSelected = (data) => {
    if (!Array.isArray(data)) return
    data = data.filter((o) => o.state?.gps?.location?.lat && o?.state?.gps?.location?.lng)
    setTrackers(data)
    if (data.length > 0) {
      let first = data[0]
      mapRef.current.flyTo({
        lat: first.state?.gps?.location?.lat,
        lng: first?.state?.gps?.location?.lng,
      })
    }
  }

  const onVehicleSelected = (data) => {
    setCurrentTracker(data)
  }

  useEffect(() => {
    setShowGeoman(
      !showEditForm &&
        showToolbar !== false &&
        (type != 'main' || (type == 'main' && featureFilterType == 'polygon'))
    )
  }, [showEditForm, showToolbar, type, featureFilterType])

  useEffect(() => {
    if (Array.isArray(realList) && realList?.length > 0) {
      let list = getPiosInPolygon()//.filter((o) => o?.latt != 0)
      // list = filterList(list, {type: 'text', val: inputFilter})
      list = sortByNearest(list)
      list = group(list)
      setPiosList(list)
      setMapZoom(true)
    } else {
      setPiosList([])
      setMapZoom(false)
    }
  }, [realList, groupBy, polygonFilterLayer, pointFilterLatLng])

  useEffect(() => {
    setGroupBy(groupPioBy || '')
  }, [groupPioBy])

  useEffect(() => {}, [filtredTrackers])

  useEffect(() => {
    if (mapRef.current && piosRef.current && mapZoom) {
      setTimeout(() => {
        mapRef.current.fitBounds(piosRef.current.getBounds())
      }, 1000)
    }
  }, [mapZoom, filterStatus, filterEtat])

  useEffect(() => {
    if (featureFilterType !== 'polygon' && polygonFilterLayer != null) {
      polygonFilterLayer?.layer?.remove()
      setPolygonFilterLayer(null)
    }
    if (featureFilterType !== 'point' && pointFilterLatLng) {
      setPointFilterLatLng(null)
    }
  }, [featureFilterType, polygonFilterLayer, pointFilterLatLng])

  useEffect(() => {
    if (Array.isArray(pios)) {
      let lst = _.cloneDeep(pios)
      setRealList(lst)
    } else {
      setRealList([])
    }
  }, [pios])

  useEffect(() => {
    if (Array.isArray(pios) && pios?.length > 0) {
      setTimeout(() => {
        const ids = pios.map((o) => o.id)
        setSelectedPioIds(ids)
      }, 500)
    }
  }, [pios])

  useEffect(() => {
    if (poiInfos) {
      let eng = lastEnginsUpdates.find((o) => o.id == poiInfos?.id)
      if (eng && eng.lastSeenAt != poiInfos?.lastSeenAt) {
        setPioInfos((prev) => ({...prev, lastSeenAt: eng.lastSeenAt}))
      }
    }
  }, [lastEnginsUpdates, poiInfos])

  useEffect(() => {
    localStorage.setItem('selected-engin-in-map', poiInfos?.id || 0)
  }, [poiInfos])

  function getDetailEngin(o) {
    setPioInfos(o)
    dispatch(setSelectedEnginMap(null))
    if (o.lat != 0 && o.lat != -1 && mapRef.current) {
      setEnginMarker([o.lat, o.lng])
      // const getZomm = mapRef.current.getZoom()
      mapRef.current.closePopup()
      mapRef.current.flyTo({lat: o.lat, lng: o.lng}, 18)
    }
  }

  const formatDate = (data) => {
    if (!data.lastSeenAt || typeof data.lastSeenAt != 'string') return '_'
    if (data.lastSeenAt.includes('+')) return moment(data.lastSeenAt).format('DD/MM/YYYY HH:mm')
    return moment.utc(data.lastSeenAt).format('DD/MM/YYYY HH:mm')
  }

  const setDataForFilter = () => {
    if (!etatVal && !statusVal) return
    if (!Array.isArray(enginMapOld.current)) return

    const filterByEtat = (item) => etatVal.value === 'all' || item.etatenginname === etatVal.value

    const filterByStatus = (item) =>
      statusVal.value === 'all' || item.statusname === statusVal.value

    const filteredData = enginMapOld.current.filter(
      (item) => filterByEtat(item) && filterByStatus(item)
    )
    console.log('Filtered Data:', filteredData)
    setEngMap(filteredData)
  }

  function clusterPopupItemTemplate(item){
    if(!item) return
    return (
      <div key={item.id} onClick={e => getDetailEngin(item)} className='flex align-items-center gap-2 mr-2 p-2 border-bottom-1 border-gray-300 cursor-pointer'>
                <div className='info flex flex-column align-items-start mx-2' style={{width: '140px' , height: 'fit-content'}}>
                  <strong className='text-m text-left' style={{fontSize: '14px'}}>
                    {item.reference}
                  </strong>
                  <div className='flex flex-row gap-2'>
                    <strong
                      style={{
                        maxWidth: '150px',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        fontSize: '9px',
                      }}
                      className='text-gray-500'
                    >
                      {item.LocationObjectname}
                    </strong>
                  </div>
                  <div style={{fontSize: '10px',}} >{lastSeenBodyTemplate(item)}</div>
                </div>
                <div className='flex flex-column align-items-start' style={{width: '80px'}}>
                  <span className="text-red-600 font-bold" style={{ fontSize: '14px' }}>
                    {item.temperature !== null ? `${item.temperature}°C` : '-'}
                  </span>
                  <span className="text-blue-600 font-bold" style={{ fontSize: '14px' }}>
                    {item.humidity !== null ? `${item.humidity}%` : '-'}
                  </span>
                </div>
       </div>
    )
  }

  function poiDetailTemplate(data , minimal){
    data = pios.find(o => o.uid == data.uid);
    console.log('data:', data)
    if(!data) return
    return (
      <div className='pio-detail-component relative'>
        {typeof itemDetailTemplate == 'function' ? (
          itemDetailTemplate(data)
        ) : (
          <div>
            <span
              className={minimal ? 'hidden' : 'pi pi-times absolute text-red-500 cursor-pointer'}
              onClick={(e) => {
                setPioInfos(null)
                setSelectedPio(null)
              }}
              style={{top: '10px', right: '10px', fontSize: '20px', zIndex: 10}}
            ></span>
            <div className=' bg-white' style={{width: minimal ? 'fit-content' : '400px'}}>
              <div className={minimal ? 'hidden' : ''}>
                <div className='flex w-full pt-2 justify-content-center align-items-center'>
                  <Image
                    src={assetConfigs.asset_server_url + data.image}
                    alt='EngineImage'
                    width='200'
                    height='200'
                    preview
                    imageStyle={{
                      objectFit: 'cover',
                      borderRadius: '10px',
                    }}
                  />
                </div>
              </div>
              <div className='p-2'>
                <div className='flex justify-content-between'>
                  <div className='flex gap-6 align-items-center'>
                    <strong>{data?.reference}</strong>
                    {data?.lastSeenAt && !minimal && (
                      <div className=' gap-2 align-items-center'>
                        <div className='flex gap-1 align-items-center'>
                          <strong>{formatDate(data)}</strong>
                          <div>
                            (<OlangItem olang='last.seen' />)
                          </div>
                        </div>
                        <div>{lastSeenBodyTemplate(data)}</div>
                      </div>
                    )}
                    {minimal && <div>{lastSeenBodyTemplate(data)}</div>}
                  </div>
                </div>
                <div className='flex gap-4 flex-wrap mt-4'>
                  <div className='ml-2 flex gap-3 align-items-center'>
                    <div className="text-center flex gap-1 align-items-center">
                      <i class="fa-regular fa-temperature-full text-red-500" style={{fontSize: '12px'}}></i>
                      <span className="text-red-600 font-bold" style={{ fontSize: '16px' }}>
                        {data.temperature !== null ? `${data.temperature}°C` : '-'}
                      </span>
                    </div>
                    <div className="text-center flex gap-1 align-items-center">
                      <i class="fa-duotone fa-regular fa-droplet-degree text-blue-500" style={{fontSize: '12px'}}></i>
                      <span className="text-blue-600 font-bold" style={{ fontSize: '16px' }}>
                        {data.humidity !== null ? `${data.humidity}%` : '-'}
                      </span>
                    </div>
                  </div>
                  <div className='hidden gap-2 align-items-center'>
                    <i
                      title={data?.statuslabel}
                      className={data.iconName + ' text-xl'}
                      style={{color: data.statusbgColor}}
                    />
                    <strong>{data?.statuslabel}</strong>
                  </div>
                  <div className='flex gap-2  align-items-center'>
                    <i className='fa-solid fa-battery-full text-green-500'></i>
                    <strong>
                      {data?.batteries > 100 ? '100%' : data?.batteries + '%'}
                    </strong>
                  </div>
                  <div className='flex gap-2 align-items-center'>
                    <span className='pi pi-wifi  text-green-500'></span>
                    <strong>{'Good'}</strong>
                  </div>
                  {!data?.sysMode === 'gateway' && (
                    <div className='flex gap-2 align-items-center'>
                      <span className='pi pi-user text-green-500'></span>
                      <strong>{data?.lastUser}</strong>
                    </div>
                  )}
                </div>
                <div className='mt-4'>
                  <div className='flex gap-2 mb-3 align-items-center'>
                    <div className='w-1 hidden'>
                      <i
                        title={data?.etatengin}
                        className={data.etatIconName + ' text-2xl'}
                        style={{color: data.etatbgColor}}
                      ></i>
                    </div>
                    <div className='ml-2'>
                      <span>Detecté dans la zone</span>
                      <strong className='text-md ml-2'>
                        {data?.LocationObjectname}
                      </strong>
                      <span className='text-gray-600 pl-2'>
                        {data?.locationDate}
                      </span>
                    </div>
                  </div>
                  <div className='flex gap-2 mb-3 align-items-center'>
                    <strong className='pl-2'>
                      <OlangItem olang='detection.mode' />: {data?.lastDetectionMode || '_'}
                    </strong>
                    <span
                      className={`${
                        data?.lastDetectionMode == 'mob'
                          ? 'pi pi-mobile text-lg text-green-500 pl-2'
                          : null
                      }`}
                    ></span>
                  </div>
                  <div className='flex ml-2 gap-2 mb-3 align-items-center'>
                    <OlangItem olang='Address' />
                    <strong className='pl-2'>{data?.enginAddress}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  useEffect(() => {
    if (inputFilter.trim() !== '') return
    setDataForFilter()
  }, [filterEt, filterSt])

  useEffect(() => {
    dispatch(fetchGeofencings())
    dispatch(fetchSites())
    dispatch(fetchCompanyAddresses())
    dispatch(fetchEnginesMap({page: 1, PageSize: 15, filterPosition: 1, displayMap: 1})).then(
      ({payload}) => {
        if (payload) {
          setEngMap(payload)
          enginMapOld.current = payload
        }
      }
    )
  }, [])

  const toggleButtons = () => {
    let circleElement = document.querySelector(
      '[title="Draw Circle"] > .leaflet-buttons-control-button'
    )
    let polygonElement = document.querySelector(
      '[title="Draw Polygons"] > .leaflet-buttons-control-button'
    )
    console.log('featureFilterType:', featureFilterType, circleElement, polygonElement)

    if (circleElement) {
      if (featureFilterType == 'polygon') {
        circleElement.classList.add('bg-blue-300')
      } else {
        circleElement.classList.remove('bg-blue-300')
      }
    }
    if (polygonElement) {
      if (featureFilterType == 'polygon') {
        polygonElement.classList.add('bg-blue-300')
      } else {
        polygonElement.classList.remove('bg-blue-300')
      }
    }
  }

  useEffect(() => {
    toggleButtons()
  }, [featureFilterType])

  useEffect(() => {
    if (!mapRef.current || !editorRef.current) return

    console.log('selectedIdsGeo:', selectedIdsGeo)

    const editor = editorRef.current
    const map = mapRef.current

    // Handle the selected geofence
    const layer = geoLayers?.[selectedGeofence?.id]
    if (layer) {
      if (selectedIdsGeo?.includes(selectedGeofence?.id)) {
        // Add the layer to the map
        editor.addLayer(layer)

        // Fit the map bounds to the layer
        map.fitBounds(layer.getBounds())

        // Add a popup to the layer
        const popupOptions = {
          closeButton: false,
          autoClose: false,
          offset: [0, -10],
        }
        const popupContent = `<div style="font-size: 12px; font-weight: bold;">${selectedGeofence?.name}</div>`
        layer.bindPopup(popupContent, popupOptions)
      } else {
        // Remove the layer and close its popup if not selected
        editor.removeLayer(layer)
        if (layer.getPopup()) layer.closePopup()
      }
    }

    // Handle additional layers for selected IDs
    if (selectedIdsGeo?.length > 0) {
      console.log('geoLayer', sites)

      const geoLayersToAdd =
        sites
          ?.filter((site) => site?.geofence?.[0]?.geometry?.type === 'Feature')
          ?.filter((site) => selectedIdsGeo.includes(site?.id)) || []

      geoLayersToAdd.forEach((site) => {
        const geometry = site?.geofence?.[0]?.geometry
        const newLayer = L.geoJSON(geometry, {
          style: {color: 'red', weight: 0.7},
          id: site.id, // Optional: attach site ID to the layer for tracking
        })

        editor.addLayer(newLayer)
      })
    } else {
      // Clear all layers if no IDs are selected
      editor.clearLayers()
    }
  }, [selectedGeofence, geoLayers, selectedIdsGeo, mapRef, editorRef])

  useEffect(() => {
    const filter = sites
      ?.filter((o) => {
        return o?.geofence.length > 0
      })
      .map((o) => ({...o?.geofence[0]?.geometry, id: o.id, geoid: o?.geofence[0]?.id}))
    setGeofences(filter)
  }, [sites])

  useEffect(() => {
    displayGeoClusters()
  }, [geoLayers, filteredPiosList])

  useEffect(() => {
    if (selectedEnginMap !== null && piosList.length > 0) {
      const findObject = piosList[0]?.items?.find((o) => o.uid === selectedEnginMap.uid)
      const index = piosList[0]?.items?.findIndex((o) => o.uid === selectedEnginMap.uid)
      console.log('index found ', index)
      if (index !== -1 && findObject) {
        const updatedPiosList = [
          findObject,
          ...(piosList[0]?.items?.slice(0, index) || []),
          ...(piosList[0]?.items?.slice(index + 1) || []),
        ]

        setPiosList([{...piosList[0], items: updatedPiosList}, ...piosList.slice(1)])
      }

      if (!findObject) {
        dispatch(fetchEngById({id: selectedEnginMap.uid}))
      }
    }
  }, [selectedEnginMap])

  useEffect(() => {
    let timer = setTimeout(() => {
      let groups = piosList.map((o) => o.label)
      let infos = piosList.reduce(
        (c, v) => {
          c.ids = [...c.ids, ...v.items.map((t) => t.id)]
          c.list = [...c.list, ...v.items]
          return c
        },
        {ids: [], list: []}
      )
      let etatConvert = etatVal.label === 'Exit' ? 'exit' : 'reception'
      let filtredId = infos.list.filter((o) => o?.etatenginname == etatConvert).map((o) => o.id)
      setSelectedPioGroups(groups)
      setFilteredPiosList(infos.list)
      if (etatVal?.label === 'All' && statusVal?.label === 'All') return
      setSelectedPioIds(filtredId)
    }, 100)

    return () => clearTimeout(timer)
  }, [piosList])

  useEffect(() => {
    displayGeofences()
  }, [geofences, editorRef.current])

  return (
    <div className={`relative ${hideClusters ? "hide-clusters" : ""}`}>
      <div
        style={{
          position: 'absolute',
          height: '400px',
          minWidth: '100%',
          width: 'auto',
          boxSizing: 'border-box',
        }}
      >
        {showEditForm && (
          <div
            style={{
              position: 'absolute',
              height: '400px',
              minWidth: '100%',
              top: '50px',
              width: 'auto',
              boxSizing: 'border-box',
              right: '7px',
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: 'auto',
                height: 'auto',
                zIndex: 10,
                padding: '3px',
                top: '0.5rem',
                right: '0.5rem',
              }}
            >
              <GeofenceEditorComponent
                _inputs={selectedGeofencePropreties}
                onSave={saveGeofenceEdit}
                onCancel={cancelGeofenceEdit}
              />
            </div>
          </div>
        )}
        {!showEditForm && (
          <div
            style={{
              position: 'absolute',
              height: '400px',
              minWidth: '100%',
              top: showGeoman ? '4rem' : '0.5rem',
              width: 'auto',
              boxSizing: 'border-box',
              right: '0.5rem',
            }}
          >
            <div
              className=''
              style={{
                position: 'absolute',
                width: 'auto',
                height: 'auto',
                zIndex: 10,
                padding: '3px',
                top: '0.5rem',
                right: '0.5rem',
              }}
            >
              {!showVehicles && !showGeofences && (
                <div className={`flex gap-2 align-items-center justify-content-end`}>
                  {
                    <ButtonComponent
                      title='Liste des sites'
                      icon={`pi pi-list`}
                      onClick={() => setShowGeofences(true)}
                    />
                  }
                  {
                    <ButtonComponent
                      title='Liste des vehicules'
                      icon={`pi pi-truck`}
                      onClick={() => setShowVehicles(true)}
                    />
                  }
                </div>
              )}
              {showGeofences && (
                <div>
                  <div className='bg-white text-right p-2 border-bottom-1 border-gray-100'>
                    <span
                      title='Cacher'
                      className='pi pi-align-right'
                      onClick={() => setShowGeofences(false)}
                    ></span>
                  </div>
                  <div>{showGeofences && <GeofenceListComponent />}</div>
                </div>
              )}
              {showVehicles && (
                <div className='mt-2'>
                  <div className='text-right bg-white p-2 border-bottom-1 border-gray-100'>
                    <span
                      title='Cacher'
                      className='pi pi-align-right'
                      onClick={() => setShowVehicles(false)}
                    ></span>
                  </div>
                  <div style={{width: '300px'}}>
                    <NavixyVehiclesListComponent
                      onVehicleSelected={onVehicleSelected}
                      onVehicleFiltered={onVehicleFiltered}
                      onVehiclesSelected={onVehiclesSelected}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {Array.isArray(piosList) && Array.isArray(pios) && (
          <div
            className='p-2 '
            style={{
              position: 'absolute',
              transition: 'all 1s',
              cursor: 'auto',
              width: 'auto',
              height: '62vh',
              zIndex: 4,
              top: '0.5rem',
              left: '0.5rem',
            }}
          >
            {showPios ? (
              <div className='flex gap-2'>
                <div className='bg-white' style={{width: '400px'}}>
                  <div className=' p-2 border-bottom-1 border-gray-100 py-2 flex align-items-center justify-content-between'>
                    <span
                      className='pi pi-align-left'
                      onClick={() => setShowPios((prev) => !prev)}
                      title='Cacher liste'
                    ></span>
                    <span
                      onClick={() => setShowFilterOptions((p) => !p)}
                      className='pi pi-cog'
                      title='Options de filtre'
                    ></span>
                  </div>
                  {showFilterOptions && (
                    <div>
                      <div className='flex gap-2 p-2 filter-options border-bottom-1 border-gray-100'>
                        <div className='border-right-1 pr-2 border-gray-300'>
                          <Chip
                            onClick={(e) => toggleOverlay(groupOverlayRef, e)}
                            label={`Grouper par: ${groupByName}`}
                            icon='pi pi-user'
                            className='cursor-pointer'
                          />
                          <OverlayPanel className='p-0 ' ref={groupOverlayRef}>
                            <div className={`-m-3`} style={{minWidth: '100px'}}>
                              {[{label: 'Pas de groupe', value: 'Tout'}, ...(groups || [])].map(
                                (s, i) => (
                                  <div
                                    onClick={(e) => {
                                      groupPiosBy(s?.value || s, s?.label || s)
                                      toggleOverlay(groupOverlayRef, e)
                                    }}
                                    className={`p-2 flex gap-2 align-items-center bg-blue-${
                                      groupBy == (s?.value || s) && 100
                                    } hover:bg-blue-100 border-top-${
                                      i != 0 && 1
                                    } border-gray-200 cursor-pointer`}
                                  >
                                    <span
                                      className={`pi pi-circle-fill text-${
                                        s?.label == 'Pas de groupe' ? 'red' : 'blue'
                                      }-300`}
                                    ></span>
                                    <span> {s?.label || s} </span>
                                  </div>
                                )
                              )}
                            </div>
                          </OverlayPanel>
                        </div>
                        <div className='flex gap-3 align-items-center'>
                          <span
                            title="Permet de filter par point le plus proche. Choisissez l'option puis cliquer sur la carte"
                            onClick={(e) => toggleFeatureFilterType('point')}
                            className={`pi pi-map-marker text-xl text-blue-${
                              featureFilterType == 'point' && 400
                            }`}
                          ></span>
                          <span
                            title="filtrer par point a l'interieur d'une zone. dessiner un polygon/cercle sur la carte"
                            onClick={(e) => toggleFeatureFilterType('polygon')}
                            className={`pi pi-map text-xl text-blue-${
                              featureFilterType == 'polygon' && 400
                            }`}
                          ></span>
                        </div>
                      </div>
                      <div className='flex flex-row gap-2 p-2 filter-options border-bottom-1 border-gray-100'>
                        <div className='border-right-1 pr-2 border-gray-300'>
                          <Chip
                            onClick={(e) => toggleOverlay(filterOverlayRef, e)}
                            label={`Filtrer par: ${filterByName}`}
                            icon='pi pi-user'
                            className='cursor-pointer'
                          />
                          <OverlayPanel className='p-0  ' ref={filterOverlayRef}>
                            <div className={`-m-3`} style={{minWidth: '100px'}}>
                              {[{label: 'Libélé', value: ''}, ...(groups || [])].map((s, i) => (
                                <div
                                  onClick={(e) => {
                                    setFilterPioBy(typeof s == 'string' ? s : s?.value)
                                    setFilterByName(typeof s == 'string' ? s : s?.label)
                                    toggleOverlay(filterOverlayRef, e)
                                  }}
                                  className={`p-2 flex gap-2 align-items-center bg-blue-${
                                    groupBy == (s?.value || s) && 100
                                  } hover:bg-blue-100 border-top-${
                                    i != 0 && 1
                                  } border-gray-200 cursor-pointer`}
                                >
                                  <span className={`pi pi-circle-fill text-blue-300`}></span>
                                  <span>{s?.label || s} </span>
                                </div>
                              ))}
                            </div>
                          </OverlayPanel>
                        </div>
                        <div className='flex gap-3 align-items-center'>
                          <Chip
                            onClick={(e) => toggleOverlay(filterOverRefEtat, e)}
                            label={<OlangItem olang={etatVal.label} />}
                            icon='fas fa-regular fa-filter-list'
                            className='cursor-pointer'
                          />
                          <OverlayPanel className='p-0 ' ref={filterOverRefEtat}>
                            <div className={`-m-3`} style={{minWidth: '100px'}}>
                              {[
                                {label: <OlangItem olang='All' />, value: 'all', icon: 'fa-ban'},
                                ...(groupsEnter || []),
                              ].map((s, i) => (
                                <div
                                  key={i}
                                  onClick={(e) => {
                                    console.log('state eeee', s)
                                    const label =
                                      s.value === 'exit'
                                        ? 'Exit'
                                        : s.value === 'reception'
                                        ? 'Enter'
                                        : 'All'
                                    filterEt({label: label, value: s.value})
                                    // setFilterEtat({label: label, value: s.value})
                                    // filterByState({label: label, value: s.value})
                                    toggleOverlay(filterOverRefEtat, e)
                                  }}
                                  className={`p-2 flex gap-2 align-items-center bg-blue-${
                                    groupBy == (s?.value || s) && 100
                                  } hover:bg-blue-100 border-top-${
                                    i != 0 && 1
                                  } border-gray-200 cursor-pointer`}
                                >
                                  <i
                                    className={`fas fa-solid ${s?.icon} ${
                                      'text-' + s?.color + '-300'
                                    }`}
                                  ></i>
                                  {/* <span className={`pi pi-circle-fill text-blue-300`}></span> */}
                                  <span>{s?.label || s} </span>
                                </div>
                              ))}
                            </div>
                          </OverlayPanel>
                        </div>
                        <div className='flex gap-3 align-items-center'>
                          <Chip
                            onClick={(e) => toggleOverlay(filterOverRefStatus, e)}
                            label={<OlangItem olang={statusVal.label} />}
                            icon='fas fa-regular fa-filter-list'
                            className='cursor-pointer'
                          />
                          <OverlayPanel className='p-0 ' ref={filterOverRefStatus}>
                            <div className={`-m-3`} style={{minWidth: '100px'}}>
                              {[
                                {label: <OlangItem olang='All' />, status: 'all', icon: 'fa-ban'},
                                ...(groupsStatus || []),
                              ].map((s, i) => (
                                <div
                                  key={i}
                                  onClick={(e) => {
                                    console.log('state eeee', s)
                                    const label = typeof s?.label === 'object' ? 'All' : s?.label
                                    const obj = {
                                      label: label,
                                      status: s?.name || 'all',
                                    }
                                    filterSt(obj)
                                    // filterByStatus(obj)
                                    toggleOverlay(filterOverRefStatus, e)
                                  }}
                                  className={`p-2 flex gap-2 align-items-center bg-blue-${
                                    groupBy == (s?.label || s) && 100
                                  } hover:bg-blue-100 border-top-${
                                    i != 0 && 1
                                  } border-gray-200 cursor-pointer`}
                                >
                                  <i
                                    style={{color: s?.backgroundColor}}
                                    className={`fas fa-solid ${s?.icon}`}
                                  ></i>
                                  {/* <span className={`pi pi-circle-fill text-blue-300`}></span> */}
                                  <span>{s?.label || s} </span>
                                </div>
                              ))}
                            </div>
                          </OverlayPanel>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='p-2 border-bottom-1 border-gray-100 py-2'>
                    <span className='p-input-icon-right p-input-icon-left  w-full '>
                      <i className='pi pi-search' />
                      <InputText
                        onChange={(e) => onFilter(e.target.value)}
                        className='w-full border-0'
                        placeholder='Search'
                      />
                    </span>
                  </div>
                  <div className='flex w-full flex-row align-items-center justify-content-between bg-blue-100 mr-2'>
                    <strong className='p-2'>
                      <OlangItem olang='lst.eng' />({piosList?.[0]?.items?.length || 0})
                    </strong>
                    <strong className='p-2'>
                      Etat: ({etatVal?.label && etatVal?.label}) - Status: (
                      {statusVal?.label && statusVal?.label})
                    </strong>
                  </div>
                  <div style={{maxHeight: showFilterOptions ? '40vh' : '53vh', overflow: 'auto'}}>
                    {piosList.map((_pio) => (
                      <div>
                        <div className='px-2 py-2 hover:bg-blue-100   flex gap-2 align-items-center justify-content-between  bg-blue-50'>
                          <div className='flex gap-2 align-items-center '>
                            <Checkbox
                              onChange={(e) =>
                                toggleSelectPioGroup(
                                  _pio.label,
                                  !selectedPioGroups.includes(_pio.label)
                                )
                              }
                              checked={selectedPioGroups.includes(_pio.label)}
                            />
                            <strong style={{fontSize: '15px'}} className='text-blue-500'>
                              {_pio.label}
                            </strong>
                          </div>
                          <div>
                            <span className='pi pi-chevron-down'></span>
                          </div>
                        </div>
                        <div className=''>
                          {(_pio.items || []).map((pio) => (
                            <div
                              //onMouseEnter={(e) => setCurrentHoveredItem(pio.id)}
                              //onMouseLeave={(e) => setCurrentHoveredItem(null)}
                              className='px-3 shadow-1 my-2 hover:shadow-3 hover:bg-indigo-100 border-left-3 border-blue-300  py-3 flex gap-2 align-items-center justify-content-between'
                              style={{
                                height: '60px',
                                marginBottom: '1px',
                                backgroundColor:
                                  (selectedEnginMap?.uid || poiInfos?.uid || selectedGeo) ===
                                  pio?.uid
                                    ? 'rgba(82, 63, 141, 0.4)'
                                    : '#f8f9fa',
                                borderRadius: '5px',
                                border:
                                  (selectedEnginMap?.uid || poiInfos?.uid || selectedGeo) ===
                                  pio?.uid
                                    ? '1px solid #523F8D'
                                    : 'none',
                              }}
                            >
                              <div
                                className='flex gap-2 align-items-center'
                                style={{minWidth: '50%'}}
                              >
                                {/* checkbox */}
                                <div className='checkbox'>
                                  <Checkbox
                                    onChange={(e) =>
                                      toggleSelectPio(pio.id, !selectedPioIds.includes(pio.id))
                                    }
                                    checked={selectedPioIds.includes(pio.id)}
                                  />
                                </div>
                                {/* image */}
                                <div className='image'>
                                  <div
                                    style={{fontSize: '15px', width: 'fit-content'}}
                                    onClick={(e) =>
                                      toggleSelectPio(pio.id, !selectedPioIds.includes(pio.id))
                                    }
                                  >
                                    {typeof itemTemplate == 'function'
                                      ? itemTemplate(pio)
                                      : pio.label}
                                  </div>
                                </div>
                              </div>
                              <div className='flex gap-1 align-items-center justify-content-end'>
                                {/* mouvement status */}
                                <div className='mouvement-status mx-1 hidden'>
                                  <i
                                    title={`${pio?.etatengin} ${pio?.locationDate}`}
                                    className={pio.etatIconName + ' text-xl'}
                                    style={{color: pio.etatbgColor, fontSize: '12px'}}
                                  />
                                </div>
                                {/* Status engin */}
                                <div className='status-engin mx-1 hidden'>
                                  <i
                                    title={pio?.statuslabel}
                                    className={pio.iconName + ' text-xl'}
                                    style={{color: pio.statusbgColor, fontSize: '12px'}}
                                  />
                                </div>
                                {/* famille tag */}
                                <div className='tag-famille mx-1'>
                                  {pio.tagId ? (
                                    <i
                                      title={pio?.familleTag}
                                      className={pio.familleIconTag + ' text-xl'}
                                      style={{color: pio.familleTagIconBgcolor}}
                                    />
                                  ) : (
                                    <span className='badge badge-secondary border-radius-2'>
                                      <OlangItem olang='No.tag' />
                                    </span>
                                  )}
                                </div>
                                {pio?.LocationID && (
                                  <div>
                                    <i
                                      onClick={() => getGeoAndDisplay(pio)}
                                      title={pio?.LocationObjectname}
                                      className={
                                        'fa fa-light fa-map-location-dot text-xl cursor-pointer hover:text-blue-500'
                                      }
                                      style={{
                                        fontSize: '12px',
                                        color: selectedGeo == pio.id ? '#29bf12' : '#00a5cf',
                                      }}
                                    />
                                  </div>
                                )}
                                <div class='mx-2 flex'>
                                  {/* distance */}
                                  {!isNaN(pio?.distanceTo) && (
                                    <span className='mr-2 text-sm '>
                                      {pio?.distanceTo} {pio?.distanceUnit}
                                    </span>
                                  )}
                                </div>
                                 <span
                                  className='pi font-semibold text-lg text-orange-600 pi-info-circle cursor-pointer'
                                  onClick={() => getDetailEngin(pio)}
                                ></span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  {inputFilter.trim().length == 0 ||
                  (Array.isArray(piosList?.[0]?.items) && piosList?.[0]?.items?.length > 0) ? (
                    <div className='w-full flex mt-3 mb-2 justify-content-center align-items-center'>
                      <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        rowsPerPageOptions={[10, 20, 30]}
                        onPageChange={onPageChange}
                        style={{width: '100%'}}
                        className='text-sm'
                        template={{
                          layout: 'PrevPageLink PageLinks NextPageLink CurrentPageReport',
                          CurrentPageReport(options) {
                            return (
                              <span className='mx-2'>
                                {options.first} à {options.last} de {options.totalRecords} élément
                              </span>
                            )
                          },
                        }}
                      />
                    </div>
                  ) : null}
                </div>
                {poiInfos && (
                  poiDetailTemplate(poiInfos)
                )}
              </div>
            ) : (
              <ButtonComponent
                icon='pi pi-align-left'
                onClick={() => setShowPios((prev) => !prev)}
                title='Liste des engins'
              />
            )}
          </div>
        )}
      </div>
      <MapContainer
        ref={mapRef}
        minZoom={1}
        maxZoom={22}
        zoom={10}
        zoomControl={false}
        center={[addressCompany?.[0]?.lat || 0, addressCompany?.[0]?.lng || 0]}
        style={{width: '100%', height: '80vh'}}
      >
        <MapEvents />
        <BaseMapLayerComponent top={60} right={15} />
        <FeatureGroup ref={editorRef}></FeatureGroup>

        <MarkerClusterGroup
          ref={piosRef}
          maxClusterRadius={150}
          iconCreateFunction={createClusterCustomIcon}
          eventHandlers={{
            clusterclick: handleClusterClick,
            popupopen: () => setHideClusters(true),
            popupclose: () => setHideClusters(false),
          }}
          zoomToBoundsOnClick={false}
          spiderfyOnMaxZoom={false}
          showCoverageOnHover={false}
        >
          {engMap.map((pio) => {
                if (
                  pio &&
                  pio?.last_lat !== 0 &&
                  pio?.last_lat !== -1 &&
                  !isNaN(pio?.last_lat) &&
                  !isNaN(pio?.last_lng)
                )
                  return (
                    <Marker
                      key={pio?.id}
                      id={pio?.id}
                      position={{lat: pio?.last_lat, lng: pio?.last_lng}}
                      icon={redIcon}
                      eventHandlers={{
                        click: (e) => {
                          e.target.openPopup() // Open popup without collapsing the cluster
                          onClickMarker(pio) // If necessary
                        }
                      }}
                    >
                      <Popup style={{ width: '400px' }}>
                        {/* {typeof pioPopupTemplate === 'function'
                          ? pioPopupTemplate(pio)
                          : pio[markerNameKey] || pio?.label} */}
                          {poiDetailTemplate(pio , true)}
                      </Popup>
                    </Marker>
                  )
              })}
        </MarkerClusterGroup>
        {clusterPopup  && (
          <Popup
            position={clusterPopup.position}
            onClose={() => setClusterPopup(null)}
          >
            <div class="flex justify-content-start flex-column">
              <div>
                <h1 style={{ margin:'0',color:'#007bff' }} className="flex align-items-center gap-2 mb-2">
                  <div className="bg-blue-500 text-white flex justify-content-center align-items-center" style={{ width: '50px' , height: '50px' , borderRadius: '50%' }}>
                      {clusterPopup.items.length}
                  </div> 
                  <span>Capteurs</span>
                </h1>
              </div>
              <div>
                {clusterPopup.items.map(clusterPopupItemTemplate)}
              </div>
            </div>
          </Popup>
        )}     

        
        <MarkerClusterGroup
          ref={trackerRef}
          maxClusterRadius={150}
          iconCreateFunction={createTrackerClusterCustomIcon}
        >
          {trackers.map((o) => (
            <Marker
              eventHandlers={{
                click: (e) => {
                  // onClickMarker(o)
                },
              }}
              position={{lat: o.state?.gps.location.lat, lng: o.state.gps.location.lng}}
              icon={dvIcon(o)}
            ></Marker>
          ))}
        </MarkerClusterGroup>
        {/* {enginMarker ? <Marker position={enginMarker} icon={customIcon} /> : null} */}
        <FeatureGroup>
          {/* <Polygon positions={[polygonFilterLatLngs]} /> */}
          {pointFilterLatLng && <Marker position={pointFilterLatLng} icon={tagIcon} />}
        </FeatureGroup>
        <GeomanComponent
          actions={Array.isArray(actions) ? actions : ['polygon']}
          show={showGeoman}
        />
        <ZoomControl position='bottomright' />
        {children}
      </MapContainer>
    </div>
  )
}


export default MapComponent
